(function ($) {

	var kualiTimer;

	function ready() {
		fixMLSPage();
	    fixPrezPageMenuActiveClass();
		//if (BreakpointController.isMobile() && /^\/admission\/academic-catalogs?/i.test(window.location.pathname)) {
		//	kualiTimer = setInterval(fixKuali, 44);	
		//}
	}

	function fixMLSPage() {
		if (/^\/about-us\/partnerships\/sports-partnerships\/major-league-soccer\/?/i.test(window.location.pathname)) {
			$("section.masthead.full > .content").css("background-position", "top center");
	    }
	}
	function fixPrezPageMenuActiveClass() {
	    if (/^\/about-us\/leadership-and-history\/president-corner\/?/i.test(window.location.pathname)) {
	        var masthead = $(".masthead.full");
	        if (masthead.find("a.active").length === 0) {
	            var test = new RegExp(window.location.pathname, "i");
	            masthead.find("a")
                    .each(function () {
                        var link = $(this);
                        if (test.test(link.attr("href"))) {
                            link.closest("li").addClass("active");
                        }
                    });
	        }
		}
	}

	//function fixKuali() {
	//	var kuali = $("#kuali-catalog");
	//	var header = kuali.find("h1");
	//	var text = header.text();
	//	if (/kuali/i.test(text)) {
	//		header.text(text.replace(/kuali/i, "Academic"));
	//		clearInterval(kualiTimer);
	//	}
	//}

	$(ready);

})(jQuery);